import { CheckboxField, Modal, TextAreaField } from 'components';
import Button from 'components/Button';
import ButtonSubmit from 'components/Forms/ButtonSubmit';
import SelectField from 'components/Forms/SelectField';
import { FormikProvider, useFormik } from 'formik';
import { Form } from 'formik-antd';
import { yup } from 'libs';
import { FC, useState } from 'react';

import SectionStyled from './styles';

interface Props {}

const EnterInformation: FC<Props> = () => {
  const [visible, setVisible] = useState<boolean>(false);
  const formik = useFormik({
    initialValues,
    validationSchema,
    async onSubmit(values) {
      console.log(values);
      setVisible(false);
      formik.resetForm();
    },
  });

  return (
    <>
      <button
        onClick={() => {
          setVisible(true);
          formik.resetForm();
        }}
      >
        Open modal EnterInformation
      </button>
      <Modal title="連絡事項入力" visible={visible} footer={false} width={640}>
        <SectionStyled>
          <FormikProvider value={formik}>
            <Form layout="vertical" className="form">
              <div className="group-input">
                <div className="box-select">
                  <Form.Item className="input-onsite" label="現場" colon={false} name="onsite">
                    <SelectField
                      data={onsites}
                      name="onsite"
                      className="select-field"
                      placeholder="現場を選択してください"
                    />
                  </Form.Item>
                  <Form.Item className="input-checkbox" label={<span />} name="push">
                    <CheckboxField name="push">プッシュ通知もあわせて行う</CheckboxField>
                  </Form.Item>
                </div>
                <Form.Item className="note-field" label="内容" name="content" colon={false}>
                  <TextAreaField
                    name="content"
                    className="text-area"
                    placeholder="連絡事項を入力してください"
                    autoSize={{ maxRows: 5 }}
                  />
                </Form.Item>
              </div>
              <div className="ant-modal-footer">
                <Button
                  className="button-secondary"
                  onClick={() => {
                    setVisible(false);
                    formik.resetForm();
                  }}
                >
                  キャンセル
                </Button>
                <ButtonSubmit>送信</ButtonSubmit>
              </div>
            </Form>
          </FormikProvider>
        </SectionStyled>
      </Modal>
    </>
  );
};

export default EnterInformation;

const onsites = [
  { label: '', value: '' },
  { label: 'name 1', value: 1 },
  { label: 'name 2', value: 2 },
  { label: 'name 3', value: 3 },
  { label: 'name 3', value: 4 },
  { label: 'name 3', value: 5 },
  { label: 'name 3', value: 6 },
  { label: 'name 3', value: 7 },
  { label: 'name 3', value: 8 },
];

const initialValues = {
  onsite: '',
  content: '',
};

const validationSchema = yup.object().shape({
  onsite: yup.number().required().label('現場'),
  content: yup.string().required().label('内容'),
});
